import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { colors, IStyles, mediaCSS, text as textStyles } from 'theme'

const displaysToolbarStyles: IStyles = {
    warningTitleWrapper: {
        ...grid.w100,
        ...grid.rowCenter,
    },
    warningTitle: {
        ...grid.w100,
        ...grid.mt_micro,
        ...textStyles.center,
        ...textStyles.normalPlus,
        ...textStyles.darkBlue,
    },
    warningDescriptionWrapper: {
        ...grid.p_md,
        ...grid.w100,
        ...textStyles.center,
        ...textStyles.normal,
        ...item.greyEditorColor,
    },
    warningDescription: {
        ...item.errorColor,
        ...textStyles.low,
        ...textStyles.bold,
    },
    sidebarHeaderCaption: {
        fontWeight: 400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        padding: '10px 24px',
        color: '#000000',
        cursor: 'pointer',
        [mediaCSS.desktopML]: {
            padding: '10px 0',

            [mediaCSS.desktopL]: {
                padding: '10px 0',
            },
        },
    },
    captionText: {
        fontSize: 16,

        [mediaCSS.desktopL]: {
            fontSize: 12,

            [mediaCSS.desktopL]: {
                fontSize: 14,
            },

            [mediaCSS.tab]: {
                fontSize: 16,
            },

            [mediaCSS.mob]: {
                fontSize: 12,
            },
        },
    },
    sidebarHeaderDropdownContent: {
        position: 'absolute',
        left: 0,
        width: '100%',
        background: colors.white,
        zIndex: 3,
        opacity: 1,
        transition: 'opacity 0.5s',
        pointerEvents: 'none',
        padding: '0 20px 20px 20px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        borderRadius: '0 0 5px 5px',

        [mediaCSS.desktopML]: {
            padding: '0 14px 20px 14px',

            [mediaCSS.desktopL]: {
                padding: '0 14px 20px 14px  ',
            },
        },
    },
    dropdownArrow: {
        position: 'absolute',
        top: 10,
        right: 20,

        [mediaCSS.desktopML]: {
            right: 6,

            [mediaCSS.desktopL]: {
                display: 'none',

                [mediaCSS.tab]: {
                    display: 'block',
                },
            },
        },
    },
    sidebarHeader: {
        position: 'relative',
        marginBottom: 20,
        background: colors.white,
        color: colors.blackLight,
        paddingTop: 36,

        [mediaCSS.desktopML]: {
            padding: 0,
            paddingTop: 36,

            [mediaCSS.desktopL]: {
                paddingTop: 24,
            },

            [mediaCSS.tab]: {
                paddingTop: 45,
            },

            [mediaCSS.mob]: {
                paddingTop: 20,
            },
        },
    },
    sidebarHeaderStatus: {
        display: 'flex',
        alignItems: 'flex-start',
        marginTop: 26,

        [mediaCSS.mob]: {
            marginTop: 20,
        },
    },
    sidebarHeaderStatusInfo: {
        marginLeft: 14,

        [mediaCSS.desktopL]: {
            marginLeft: 8,
        },

        [mediaCSS.mob]: {
            marginLeft: 10,
        },
    },
    sidebarHeaderStatusInfoCaption: {},
    sidebarHeaderStatusInfoDescription: {
        fontStyle: 'italic',
        fontSize: 10,
        fontWeight: 300,
        lineHeight: 1.3,
        marginTop: 6,
    },
}

addStyles(displaysToolbarStyles)
export default displaysToolbarStyles
